import React from 'react'
import { Link } from 'react-router-dom'
import Autocompete from './Autocompete'
import JobHeader from './JobHeader'
import SideBar from './SideBar'
import './Compensation.css'
export default function Compensation() {
  return (
<>
<JobHeader/>
<div class ="jobProcess">
  <SideBar/>
  <div class ="compensation">
    <h1>Compensation</h1>
       <div className='total-base-pay'>
       <h2>Total Base Pay</h2>
       Total Base Pay
       <br/>
       0.00 USD Annual added
       </div>
       <div className='guidelines'>
        <h2>Guidelines</h2><br/>
        <div className='Guide-h'> 
        <h4>Total Base Pay Range</h4>
        </div>
        <br/>
        <div className='Guide-l'><ul><li>88400.00 - 123,800.00- 159,200.00 USD Annual added</li></ul></div>
        <div className='Guide-h'>  <h4>Compensation Package</h4></div> 
        <div className='Guide-l'><ul><li>Varian Compensation Package added</li></ul></div>
        <div className='Guide-h'>  <h4>Grade</h4></div>
        <div className='Guide-l'><ul><li>Compensation Grade added</li></ul></div>
        <div className='Guide-h'>  <h4>Grade Profile</h4></div> 
          <div className='Guide-l'><ul><li> USA-A-G12 added</li></ul></div>
        <div className='Guide-h'><h4>Step</h4></div> 
        (empty)
        <div className='Guide-h'><h4>Progression Start Date</h4></div>
        (empty)\</div>
        <div className='salary'>
          <h1>Salary</h1>
          <div className='Guide-h'>  <h4> Assignment Details </h4></div>
          <div className='Guide-l'><ul><li> 0.00 USD Annual added</li></ul></div>
          <div className='Guide-h'>  <h4> Plan Name </h4></div>
          <div className='Guide-l'><ul><li>Salary Plan added</li></ul></div>
          <div className='Guide-h'>  <h4> Effective Date</h4></div>
          <div className='Guide-l'><ul><li> 07/15/2021 added</li></ul></div>
          <div className='Guide-h'>  <h4> Compensation Plan </h4></div>
        Salary Plan
        <div className='Guide-h'>  <h4>Total Base Pay Range </h4></div>
        <div className='Guide-h'>  <h4> Apply Fte%</h4></div>
        <div className='Guide-l'>Yes</div>
<div className='Guide-h'><h4>Amount<span className="mandatory">*</span></h4></div>
       <input type='number' className='input-amount'/>
       </div>
        
        <div className='Period-salary'>
        <h1>Period Salary</h1>
        <button className='Add'>Add</button>
          </div>
          <div className='Allowance'>
        <h1>Allowance</h1>
        <button className='Add'>Add</button>
          </div>
          <div className='Bonus'>
            <h1>Bonus</h1>
        <h4>Assignment Details</h4>
        <div className='Guide-l'><ul><li>10% Annual added</li></ul></div>
        <div className='Guide-h'>  <h4> Plan Name</h4></div>
        <div className='Guide-l'><ul><li>Varian Performance Icentive Plan (VPIP) added</li></ul></div>

        <div className='Guide-h'>  <h4> Effective Date</h4></div>
        <div className='Guide-l'><ul><li>07/15/2021 added</li></ul></div>
          </div>

        </div>
        </div>
        <div className='next-bar'>
    <button className='back-btn'>Back</button>
    <button className='next-btn'>Next</button>
    
        </div>
   
    </>
  )
}

